import React from 'react';
import dayjs from 'dayjs';
import { css } from 'aphrodite/no-important';
import { FormattedMessage, useIntl } from 'react-intl';
import { StatusMessage, MessageMood, Tag } from '@trainline/depot-web';
import { Payment } from 'packages/hooks/api/useFetchJourneys';

import FormattedCurrency from '@contactcentre-web/common/FormattedCurrency/FormattedCurrency';

import messages from '../messages';

import styles from './styles';

interface Props {
  payment: Payment;
  isCurrent: boolean;
  lastDayOfSelectedPeriod?: string;
}

const TransactionsList = ({ payment, isCurrent, lastDayOfSelectedPeriod }: Props) => {
  const { formatMessage } = useIntl();
  return (
    <div className={css(styles.container)}>
      <section className={css(styles.transactionsSection)}>
        {isCurrent && (
          <div className={css(styles.warning)}>
            <StatusMessage
              mood={MessageMood.WARNING}
              body={formatMessage(messages.onGoingOrderWarning, {
                endingDate: dayjs(lastDayOfSelectedPeriod).format('D MMMM'),
              })}
            />
          </div>
        )}
        {payment.transactionsList.map((transaction, index) => (
          <div key={`transaction-${index}`} className={css(styles.transactionContainer)}>
            <div
              className={css([
                styles.transaction,
                transaction.transactionStatus === 'Failed' && styles.failed,
              ])}
            >
              <span>{dayjs(transaction.date).format('D MMMM')}</span>
              <section className={css(styles.rightSection)}>
                <p className={css(styles.amount)}>
                  <FormattedCurrency
                    amount={transaction.amount.value}
                    currency={transaction.amount.currencyCode}
                  />
                </p>
                {transaction.transactionStatus === 'Failed' && (
                  <Tag
                    label={formatMessage(messages.failed)}
                    mood={MessageMood.NEGATIVE}
                    typeStyle="micro"
                  />
                )}
              </section>
            </div>
            {transaction.includesPreviousCharges && (
              <p className={css(styles.subduedText)}>
                <FormattedMessage {...messages.includesPreviousCharges} />
              </p>
            )}
          </div>
        ))}
      </section>
      <section className={css([styles.total, styles.subduedText])}>
        <FormattedMessage {...messages.total} />
        <FormattedCurrency amount={payment.total.value} currency={payment.total.currencyCode} />
      </section>
    </div>
  );
};

export default TransactionsList;
